import {FC, useEffect, useState} from "react";
import {IDataForSearchSidebar, ITypeRadar} from "../../../types";
import {colors} from "../../../mocks/projectsMock";
import CardItem from "../../CardItem";
import {SidebarTab} from "../../Sidebar";
import {ITehnologieAll} from "../../../pages/Dashboard/Dashboard.type";

interface IProps {
  searchDatasidebarInfo?: IDataForSearchSidebar;
  allTechnologies: ITehnologieAll[];
  isShowTitleParams: boolean;
  id: string | number;
  clusterId: number | string;
  name: string;
  openSidebarWithTab: (
    tab: SidebarTab,
    directionId: number | string,
    clussterId?: number | string,
    name?: any,
    sectionName?: any,
    innerColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: ITypeRadar
  ) => void;
  typeRadar: ITypeRadar;
}

export const SidebarCardSearchTechnologiesItem: FC<IProps> = ({
  searchDatasidebarInfo,
  isShowTitleParams,
  id: technologieId,
  clusterId,
  name: technologieName,
  openSidebarWithTab,
  typeRadar,
  allTechnologies,
}) => {
  const [showDirectionsBlock, setShowDirectionsBlock] = useState(true);

  const [quantitiesItemsToShow, setQuantitiesItemsToShow] = useState(2);

  const resultFind = allTechnologies?.filter(
    (itemTechnologie) => technologieId === itemTechnologie.documentId
  );

  useEffect(() => {
    setQuantitiesItemsToShow(2);
  }, [searchDatasidebarInfo]);

  const handleCardClick = () => {
    const findTechnologie = allTechnologies?.find(
      (item) => item.id === technologieId
    );
    const clusterObj = searchDatasidebarInfo?.clusters?.find(
      (item) => item.id === clusterId
    );
    const directionObj = searchDatasidebarInfo?.directions?.find(
      (item) => item.id === clusterObj?.direction_id
    );

    const segmentLabels =
      searchDatasidebarInfo?.directions &&
      searchDatasidebarInfo?.directions?.map((item) => {
        // if (typeRadar === "stateInitiative") return item.documentId;
        return item.documentId;
      });
    const color = segmentLabels
      ?.map((item, i) =>
        item === findTechnologie?.documentId ? colors[i] : null
      )
      .find((item) => item !== null);

    openSidebarWithTab(
      SidebarTab.CPU,
      clusterObj?.direction_id ?? "",
      clusterId,
      clusterObj?.name,
      directionObj?.name,
      color ?? undefined,
      technologieName,
      technologieId,
      typeRadar
    );
  };
  return (
    <div style={{marginTop: 20}}>
      {showDirectionsBlock && (
        <>
          {resultFind?.slice(0, quantitiesItemsToShow).map((item: any) => {
            return (
              <>
                <CardItem
                  key={item.id}
                  invest_volume_tier={item.invest_volume_tier}
                  market_volume_tier={item.market_volume_tier}
                  potential_volume_tier={item.potential_volume_tier}
                  trl_tier={item.trl_tier}
                  title={item.name}
                  isFlashFilterEnabled={item.growth_potential}
                  isCritical={item.critical}
                  isNational={item.national}
                  isGpb={item.gpb}
                  type={SidebarTab.Clusters}
                  onClick={() => handleCardClick()}
                  imageCard={item.image}
                  isShowTitleParams={isShowTitleParams}
                  typeRadar={typeRadar}
                  batteryRussia={item.battery_russia}
                  batteryWorld={item.battery_world}
                />
              </>
            );
          })}
        </>
      )}
    </div>
  );
};
